import styled from "styled-components";

export const Root = styled.div.attrs({ role: "button", tabIndex: 0 })`
  width: 414px;
  min-width: 414px;
  max-width: 414px;
  border: 0;
  padding: 0;
  background: transparent;
  color: ${({ theme }) => theme.palette.colors.text};
  text-align: left;
  cursor: pointer;
  transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);

  &:hover {
    transform: translateY(-5px);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.blue.main};
    outline-offset: 4px;
  }

  @media (max-width: 991px) {
    width: min(414px, 100%);
    min-width: min(414px, 100%);
    max-width: min(414px, 100%);
  }
`;

export const DocumentShell = styled.div`
  position: relative;
  height: 232.875px;
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  border-radius: 14px;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.colors.surfaceElevatedStrong};
  box-shadow:
    0 18px 42px ${({ theme }) => theme.palette.colors.shadowStrong},
    inset 0 1px 0 ${({ theme }) => theme.palette.colors.borderSoft};

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    background:
      linear-gradient(180deg, rgba(2, 6, 24, 0.12) 0%, rgba(2, 6, 24, 0) 42%),
      linear-gradient(0deg, rgba(2, 6, 24, 0.26) 0%, rgba(2, 6, 24, 0) 48%);
    pointer-events: none;
  }
`;

export const TopMeta = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 16px;
`;

export const DocumentBadge = styled.div`
  min-height: 26px;
  border-radius: 999px;
  padding: 5px 10px;
  background: ${({ theme }) => theme.palette.blue.main};
  color: ${({ theme }) => theme.palette.blue.contrastText};
  font-size: 13px;
  font-weight: 800;
  line-height: 16px;
  box-shadow: 0 8px 18px rgba(21, 93, 252, 0.3);
`;

export const ActionLabel = styled.div`
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border-radius: 999px;
  background: rgba(2, 6, 24, 0.48);
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 800;
  line-height: 16px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.22);
`;

export const DocumentPreview = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.palette.colors.surfaceElevatedStrong};
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
  user-select: none;
  pointer-events: none;
  transition: transform 0.32s ease;

  ${Root}:hover & {
    transform: scale(1.025);
  }
`;

export const PreviewFallback = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(135deg, rgba(21, 93, 252, 0.16), rgba(21, 93, 252, 0)),
    ${({ theme }) => theme.palette.colors.surface};
`;

export const DocumentIcon = styled.div`
  width: 84px;
  height: 84px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.blue.main};
  background: ${({ theme }) => theme.palette.colors.badgeMuted};
`;

export const DocumentTitle = styled.div`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 16px;
  font-family: Gilroy;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.14;
  letter-spacing: 0;
  color: ${({ theme }) => theme.palette.colors.text};
`;

export const MetaLine = styled.div`
  min-width: 0;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  span {
    min-height: 24px;
    border-radius: 999px;
    padding: 4px 10px;
    background: ${({ theme }) => theme.palette.colors.badgeMuted};
    color: ${({ theme }) => theme.palette.colors.muted};
    font-size: 13px;
    font-weight: 800;
    line-height: 16px;
  }
`;
